import Store from '../models/Store';

class CommonStore extends Store {
    setUser(user){
        this.state.user = user;
    }
    setMinHeight(n){
        this.state.minHeight = n;
    }
}
export default new CommonStore({
    user:null,
    minHeight:0
})



// WEBPACK FOOTER //
// src/lib/store.js